$(function() {
  $(window).on('load',function(){
    if (!isMobile()) {
      $('body').addClass('no-scroll')
      $("#splash-logo").delay(1000).fadeOut('slow');//ロゴを1.2秒でフェードアウトする記述
    
      //=====ここからローディングエリア（splashエリア）を1.5秒でフェードアウトした後に動かしたいJSをまとめる
      $("#splash").delay(1500).fadeOut('slow',function(){//ローディングエリア（splashエリア）を1.5秒でフェードアウトする記述
      
        
      });
      // 1.8秒後に実行
      setTimeout(function() {
        // $('body').addClass('appear');//フェードアウト後bodyにappearクラス付与
        $('body').removeClass('no-scroll')
      }, 1500);
      //=====ここまでローディングエリア（splashエリア）を1.5秒でフェードアウトした後に動かしたいJSをまとめる
    }
  });

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  // 要素が画面内に入ったかをチェックする関数
  // クラス名を引数として受け取る
  function checkVisibility(className) {
    $(className).each(function() {
      const $element = $(this)
      const elementTop = $element.offset().top
      const elementBottom = elementTop + $element.outerHeight()

      const viewportTop = $(window).scrollTop()
      const viewportBottom = viewportTop + $(window).height()

      // 要素がビューポートの下端から100px内に入ったか判定
      // この値を増やすことで、より下で反応させることができる
      const threshold = 100; // 反応させたい距離（px）

      // 要素が画面内に入ったか判定
      if (elementBottom > viewportTop && elementTop < (viewportBottom - threshold)) {
        $element.addClass('visible')
      } else {
        // スクロールアウトした要素を再度非表示にする場合は以下を有効化
        // $element.removeClass('visible')
      }
    });
  }

  // スクロールとリサイズイベントに関数をバインドし、引数としてクラス名を渡す
  $(window).on('scroll resize', function() {
    checkVisibility('.fadeIn')
    checkVisibility('.fadeBg')
  })

  // 初期ロード時にも実行し、引数としてクラス名を渡す
  checkVisibility('.fadeIn')
  checkVisibility('.fadeBg')


   // スクロール時のヘッダーの挙動とハンバーガーメニューのリセットを制御する関数
  function ScrollAnime() {
    var scroll = $(window).scrollTop();
    // up_areaクラスのスクロール値を取得
    var upAreaScrollTop = 900;
    // ヘッダーが上に消える時にハンバーガーメニューをリセット

    if(scroll === 0) {
      $('.Header').removeClass('UpMove').removeClass('DownMove');
    } else if(scroll < 20) {
      $('.Header').addClass('UpMove')
    } else if (scroll > upAreaScrollTop) {
      $('.Header').removeClass('UpMove').addClass('DownMove');
    } else {
      $('.Header').removeClass('DownMove').addClass('UpMove');
    }

    beforePos = scroll; // 現在のスクロール値を格納
  }

  // スクロールとページロード時に関数を実行
  $(window).scroll(ScrollAnime);
  $(window).on('load', ScrollAnime);

  var count = 0;
  if ($('#slider').length) {
    var list = $('#slider').html();
    for (var i = 0; i < 10; i++) {
      $('#slider').append(list);
    }

    $('#slider').slick({
      autoplay: false,
      speed: 1500,
      dots: false,
      infinite: true,
      centerMode: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToShow: 7,
      swipe: false,
      arrows: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: 0,
        }
      }]
    });

    reverseAutoplay();

    setTimeout(function() {
      $('#slider').addClass('is-active');
      $('.Header').removeClass('initial');
      $('.Fv__logo__under-wrapper').removeClass('initial');
    }, 2000);


    // 自動再生をカスタマイズして逆方向にスライド
    function reverseAutoplay() {
      $('#slider').slick('slickPrev');
    }
    setInterval(reverseAutoplay, 3000); // 3000msごとにslickPrevを呼び出す

    $('#slider').on('setPosition', function() {
      if (count == 0) {
        $('.slick-current').prev().addClass('left');
        $('.left').prev().addClass('left2');
        $('.left2').prev().addClass('left3');
        $('.left3').prev().addClass('left4');
        $('.slick-current').next().addClass('right');
        $('.right').next().addClass('right2');
        $('.right2').next().addClass('right3');
        $('.right3').next().addClass('right4');
      }
      count++;
    });
    $('#slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      let next = '[data-slick-index="' + nextSlide + '"]'; 
      $('#slider img').removeClass('right left right2 left2 right3 left3 right4 left4');
      $(next).prev().addClass('left');
      $('.left').prev().addClass('left2');
      $('.left2').prev().addClass('left3');
      $('.left3').prev().addClass('left4');
      $(next).next().addClass('right');
      $('.right').next().addClass('right2');
      $('.right2').next().addClass('right3');
      $('.right3').next().addClass('right4');
    });
  }

  // ハンバーガーメニュー
  $('.Hamburger-menu__wrapper').on('click', function() {
    $('.Hamburger-menu__bar').toggleClass('open');
    $('body').toggleClass('no-scroll');
    $('.Drawer-menu__mask').toggleClass('open');
    $('.Drawer-menu__nav').toggleClass('open');
  });

  $('.Drawer-menu__nav__link').on('click', function() {
    $('.Hamburger-menu__bar').removeClass('open');
    $('body').removeClass('no-scroll');
    $('.Drawer-menu__mask').removeClass('open');
    $('.Drawer-menu__nav').removeClass('open');
  });

  // 開催概要タブメニュー
  $('.Summary__sp-tab__btn').on('click', function() {
    $(this).siblings().removeClass('active'); // 兄弟要素から 'active' クラスを削除
    $(this).addClass('active'); // クリックされた要素に 'active' クラスを追加

    var tabType = $(this).hasClass('summit') ? 'summit' : 'social'; // クリックされたタブのタイプを判定
    var $wrapper = $(this).closest('.Summary__contents__wrapper'); // 最も近い親のラッパー要素を取得

    // すべてのタブとコンテンツから 'active' クラスを削除
    $wrapper.find('.Summary__sp-tab__btn, .Summary__contents').removeClass('active');

    // クリックされたタブと対応するコンテンツに 'active' クラスを追加
    $(this).addClass('active');
    $wrapper.find('.Summary__contents.' + tabType).addClass('active');
  })

  $('.Results__bottom-section__slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6900,
    dots: false,
    infinite: true,
    auseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'linear',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerPadding: 0,
      }
    }]
  });

  // プログラムアコーディオン
  if ($(window).width() < 768) {
    $('.Program__contents__schedule__text-wrapper').on('click', function() {
      $(this).toggleClass('open');
    });

    $('.accordion-target').on('click', function() {
      $(this).toggleClass('open');
    });
  }

  // 参加事務所スライダー
  $('.Participation__slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 18000,
    dots: false,
    infinite: true,
    auseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
        centerPadding: 0,
      }
    }]
  });

  // スクロールヒント
  // タッチまたはスクロールイベントを監視する要素を指定
  const $tableWrapper = $('.Information__bottom-section__table-wrapper');
  const $scrollHint = $('.Information__bottom-section__table__scroll-hint');

  // ウィンドウの幅が768px以下の場合にのみイベントハンドラを設定
  if ($(window).width() <= 768) {
      $tableWrapper.on('touchmove scroll', function() {
          $scrollHint.addClass('hidden');
      });
  }
});
